import { sendGoogleEvent } from '@html/_common/utils';

export default class AOTourBrochure {
  constructor(tourId, tourName, tourOperatorName, netRevenue) {
    this.tourId = tourId;
    this.tourName = tourName;
    this.tourOperatorName = tourOperatorName;
    this.netRevenue = netRevenue;
    this.initiated = false;
  }

  renderBrochure = (e) => {
    e.preventDefault();
    const dataSource = $(e.currentTarget).attr('data-source');

    import(/* webpackChunkName: "brochure" */'@html/_common/brochure').then((module) => {
      const Brochure = module.default;

      const brochure = new Brochure();
      /* prepare parameters */
      const $obj = $('main').first();
      const tourCredits = $obj.attr('data-sym') + Math.min(parseInt($obj.attr('data-price'), 10) * 0.05, 250);
      const tourPrice = $obj.data('price');
      const eventActionSuccess = 'Open Thank you - TDP';

      /* load and show popup */
      if (!this.initiated) {
        brochure.load(() => {
          this.initiated = true;

          brochure.initiatePopup($obj);
          brochure.fillForm(
            this.tourId,
            this.tourName,
            this.tourOperatorName,
            this.netRevenue,
            tourCredits,
            tourPrice,
            eventActionSuccess,
          );
        });
      } else {
        brochure.fillForm(
          this.tourId,
          this.tourName,
          this.tourOperatorName,
          this.netRevenue,
          tourCredits,
          tourPrice,
          eventActionSuccess,
        );
      }

      let brochureSource = '';

      if (dataSource === 'plan-adventure') {
        brochureSource = 'Plan your adventure';
      } else if (dataSource === 'read-later-brochure') {
        brochureSource = 'Below Itinerary';
      }

      sendGoogleEvent(
        'Download Brochure',
        'Open Enter Email - TDP',
        this.tourName,
        {
          dimension10: this.tourId,
          ampEventName: 'brochure_download_form_opened',
          itemName: this.tourName,
          tourName: this.tourName,
          tourID: this.tourId,
          tourOperator: this.tourOperatorName,
          brochure_source: brochureSource,
        },
      );
    });
  };

  initiate() {
    $(
      '.js-ao-tour-start-planning-your-tour__cta-brochure,'
      + '.js-ao-tour-read-later-cta-banner__button,'
      + '.js-ao-tour-bottom-banner__cta-brochure',
    ).on('click', (e) => this.renderBrochure(e));
  }
}
